import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { savedTokens } from 'src/auth'
import { savedOrganization } from '../Onboarding/storage'
import { useLogging } from './queries'

export default function Logging() {
  const logger = useLogging()
  const location = useLocation()

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      const tokens = savedTokens.get()

      logger.mutate.call(undefined, {
        type: 'location',
        organization: tokens?.organization ?? savedOrganization.get() ?? '-',
        location: location.pathname + location.search,
      })
    }
  }, [location, logger.mutate])

  return null
}
